// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ibedA","toggle":"styles_toggle__Z9Wa3"};